<template>
  <div>
    <h3>selector</h3>
    <pen-selector
      v-for="(penProps, index) in propertys"
      :key=index
      :penProps="penProps"
      :active="activeProperty.id === penProps.id"
      @click="selectProperty(penProps.id)"
    />

    <el-button-group>
      <el-button size="mini" type="success" @click="copyPenproperty(activeProperty.name + '_copy')">copy pen</el-button><br>
      <el-button size="mini" type="danger" @click="removeProperty(activeProperty.id)">remove pen</el-button><br>
      <el-button size="mini" type="danger" @click="resetPropertys()">reset pens</el-button>
    </el-button-group>

    <h3>propertys</h3>
    <el-input v-model="propertyName" />
    <div>
      <div>color</div>
      <el-color-picker
        show-alpha
        v-model        ="lineColorModel"
        :predefine     ="predefineColors"
        @active-change ="changeLineColor"
      />
    </div>
    <div>
      <span>width {{ lineWidthModel }}</span>
      <el-slider
        v-model ="lineWidthModel"
        :min    ="1"
      />
    </div>
    <div>
      <span>blur {{ blurModel }}</span>
      <el-slider
        v-model="blurModel"
      />
    </div>
    <div>
      <span v-if="alphaModel < 101" >alpha {{ alphaModel }}</span>
      <span v-else>alpha auto</span>
      <el-slider
        :max            ="101"
        :min            ="1"
        v-model         ="alphaModel"
        :format-tooltip ="val => val/100"
      />
    </div>
    <div>
      <el-radio-group v-model="type">
        <el-radio-button label="pen" />
        <el-radio-button label="eraser" />
      </el-radio-group>
    </div>
    <div>
      <el-radio-group v-model="lineCapModel">
        <el-radio-button label="round" />
        <el-radio-button label="square" />
      </el-radio-group>
    </div>
  </div>
</template>

<script lang="">
import { mapGetters, mapActions, mapMutations } from 'vuex'
import penSelector from './penProperty-penSelector'

const penTypes = {
  pen    : 'source-over',
  eraser : 'destination-out'
}

export default {
  data () {
    return {
      predefineColors: [
        'rgba(0,0,0,1)',
        'rgba(255,0,0,1)',
        'rgba(0,255,0,1)',
        'rgba(0,0,255,1)',
        'rgba(170, 0, 255, 1)',
        'rgba(255,255,255,1)'
      ]
    }
  },
  computed: {
    ...mapGetters('canvas', [
      'lineColor',
      'lineWidth',
      'blur',
      'alpha',
      'lineCap',
      'propertys',
      'selecting',
      'composite',
      'activeProperty'
    ]),
    propertyName: {
      get () { return this.activeProperty.name },
      set (value) { this.updateProperty({ type: 'name', value: value }) }
    },
    lineColorModel: {
      get () { return this.activeProperty.lineColor },
      set (value) { this.updateProperty({ type: 'lineColor', value: value }) }
    },
    lineWidthModel: {
      get () { return this.activeProperty.lineWidth },
      set (value) { this.updateProperty({ type: 'lineWidth', value: value }) }
    },
    blurModel: {
      get () { return this.activeProperty.blur },
      set (value) { this.updateProperty({ type: 'blur', value: value }) }
    },
    alphaModel: {
      get () { return this.activeProperty.alpha ? this.activeProperty.alpha * 100 : 101 },
      set (value) { this.updateProperty({ type: 'alpha', value: value < 101 ? value / 100 : false }) }
    },
    type: {
      get () { return Object.keys(penTypes).filter(key => penTypes[key] === this.activeProperty.composite)[0] },
      set (value) { this.updateProperty({ type: 'composite', value: penTypes[value] }) }
    },
    lineCapModel: {
      get () { return this.activeProperty.lineCap },
      set (value) { this.updateProperty({ type: 'lineCap', value: value }) }
    }
  },
  methods: {
    ...mapActions('canvas', [
      'changeLineColor',
      'changeLineWidth',
      'changeblur',
      'changealpha'
    ]),
    ...mapMutations('canvas', [
      'changeName',
      'changeLineCap',
      'selectProperty',
      'copyPenproperty',
      'removeProperty',
      'resetPropertys',
      'changeComposite',
      'updateProperty'
    ])
  },
  components: {
    penSelector
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/canvas/controller/penProperty.vue